// import Rectangle84 from "../../assets/img/Rectangle84.png";
// import profileImage from '../../assets/img/profile-image.jpg';
// import Rectangle89 from "../../assets/img/Rectangle91.png";
// import icon from "../../assets/img/icon.png";
// import Co/mmentItem from "./CommentItem";
import React, { useState } from 'react';
import hooks from "./ChangeEmailHook";
import ModalComp from '../../../components/ModalComp/ModalComp';
import LoginInputs from "../../../components/TextInput/LoginInputs/LoginInputs";
import NumberFormatInput from "../../../components/TextInput/LoginInputs/NumberFormatInput";
import MainButton from "../../../components/ButtonsCont/MainButton";
import ClipLoader from "react-spinners/ClipLoader";
import validation from "../../../utils/validation";
import { StylesProvider } from '@material-ui/core';
import styles from "./changeEmail.module.scss";

function ChangeEmail(props) {
    const { showCode, set_input_value, change_email, edit_email_saga, keyPress, check_email_saga, translate } = hooks(props);
    const body = (
        <div>
            {!showCode ? <div>
                <div className="d-flex justify-content-center m-3">{translate.emailPlaceholderLabel}</div>
                <LoginInputs
                    placeholder="Email"
                    valid={change_email.data.email.valid}
                    value={change_email.data.email.value}
                    submitted={change_email.submitted}
                    error_message="email error"
                    onKeyDown={(e) => keyPress(e)}
                    onChange={(value) => { set_input_value({ label: "email", data: validation({ value, type: "email" }) }); }} />
                <div className="d-flex justify-content-center">
                    <MainButton onClick={() => edit_email_saga()} title={change_email.loading ? <ClipLoader color="#464646" size={15} /> : translate.saveLabel} />
                </div>
            </div> : <div>
                <div className={styles.title}>{translate.enter_code}</div>
                <div className={styles.description}>{translate.confirmMailTextLabel}</div>
                {/* <NumberInput
                    valid={change_email.data.confirm_code.valid}
                    value={change_email.data.confirm_code.value}
                    submitted={change_email.code_submitted}
                    onKeyDown={(e) => keyPress(e)}
                    onChange={(value) => { set_input_value({ label: "confirm_code", data: validation({ value, type: "code" }) }) }}
                /> */}
                <NumberFormatInput
                    type="code"
                    placeholder=""
                    value={change_email.data.confirm_code.value}
                    valid={change_email.data.confirm_code.valid}
                    submitted={change_email.code_submitted}
                    onChange={(value) => {
                        set_input_value({ label: "confirm_code", data: validation({ value, type: "code" }) });
                    }}
                    error_message="error code"
                />
                <div className="d-flex justify-content-center">
                    <MainButton onClick={() => {
                        if (!change_email.loading) {
                            check_email_saga();
                        }
                    }} title={change_email.loading ?
                        <ClipLoader color="#464646" size={15} /> : translate.saveLabel} />
                </div>
            </div>}

        </div>
    );
    return (
        <ModalComp body={body} open={props.open} setValue={() => props.setValue()} />
    );
}
export default ChangeEmail;